import React from "react"

// Components
import QuotesPanelHeader from "./quotes.panel.header"

const QuoteView = () => <QuotesPanelHeader />

export default QuoteView
